const ArrowDownRight01Icon = /*#__PURE__*/ [
  ["path", { d: "M9 17.3497C9 17.3497 15.9383 17.8924 16.9154 16.9154C17.8924 15.9383 17.3496 9 17.3496 9M16.5 16.5L6.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowDownRight01Icon as default };
//# sourceMappingURL=ArrowDownRight01Icon.js.map
